
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import Card from '../../components/base/Card';

export default function Login() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('email', formData.email);
      formDataToSend.append('password', formData.password);
      formDataToSend.append('rememberMe', formData.rememberMe ? 'Evet' : 'Hayır');

      const response = await fetch('https://readdy.ai/api/form/d3jmt5hd1hbhs86av150', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitMessage('Giriş başarılı! Yönlendiriliyorsunuz...');
        // Simulate redirect after successful login
        setTimeout(() => {
          // In a real app, you would redirect to dashboard
          setSubmitMessage('Giriş yapıldı. Dashboard sayfası henüz hazır değil.');
        }, 1500);
      } else {
        setSubmitMessage('E-posta veya şifre hatalı. Lütfen tekrar deneyin.');
      }
    } catch (error) {
      setSubmitMessage('Bağlantı hatası. Lütfen tekrar deneyin.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <section className="py-20">
        <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
              <span className="text-yellow-600">Giriş Yap</span>
            </h1>
            <p className="text-lg text-gray-600">
              Hesabınıza giriş yapın ve yarışma durumunuzu takip edin
            </p>
          </div>

          <Card>
            <form onSubmit={handleSubmit} data-readdy-form id="login-form">
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  E-posta
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-400 focus:border-transparent text-sm"
                  placeholder="ornek@email.com"
                />
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Şifre
                </label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-400 focus:border-transparent text-sm"
                  placeholder="Şifrenizi girin"
                />
              </div>

              <div className="flex items-center justify-between mb-6">
                <label className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    name="rememberMe"
                    checked={formData.rememberMe}
                    onChange={handleInputChange}
                    className="w-4 h-4 text-yellow-600 border-gray-300 rounded focus:ring-yellow-400"
                  />
                  <span className="text-sm text-gray-700">Beni hatırla</span>
                </label>
                
                <Link to="/forgot-password" className="text-sm text-yellow-600 hover:text-yellow-700">
                  Şifremi unuttum
                </Link>
              </div>

              {submitMessage && (
                <div className={`mb-6 p-4 rounded-lg ${
                  submitMessage.includes('başarılı') 
                    ? 'bg-green-100 text-green-700 border border-green-200' 
                    : 'bg-red-100 text-red-700 border border-red-200'
                }`}>
                  {submitMessage}
                </div>
              )}

              <Button 
                type="submit" 
                size="lg" 
                className="w-full" 
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line mr-2 animate-spin"></i>
                    Giriş Yapılıyor...
                  </>
                ) : (
                  <>
                    <i className="ri-login-box-line mr-2"></i>
                    Giriş Yap
                  </>
                )}
              </Button>
            </form>

            <div className="mt-6 text-center">
              <p className="text-gray-600">
                Hesabınız yok mu?{' '}
                <Link to="/register" className="text-yellow-600 hover:text-yellow-700 font-medium">
                  Kayıt Ol
                </Link>
              </p>
            </div>
          </Card>

          {/* Quick Stats */}
          <div className="mt-12 grid grid-cols-3 gap-4">
            <Card padding="sm" className="text-center">
              <div className="text-2xl font-bold text-yellow-600">5M TL</div>
              <div className="text-xs text-gray-600">Toplam Ödül</div>
            </Card>
            <Card padding="sm" className="text-center">
              <div className="text-2xl font-bold text-yellow-600">1.000</div>
              <div className="text-xs text-gray-600">Kazanan</div>
            </Card>
            <Card padding="sm" className="text-center">
              <div className="text-2xl font-bold text-yellow-600">29</div>
              <div className="text-xs text-gray-600">Farklı Ödül</div>
            </Card>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
